module.exports = __webpack_public_path__ + "static/media/checkmark.ec385f73.svg";